import { createContext } from 'react';
import { Outlet } from 'react-router-dom';
import type { RestrictedRouteObject } from './types';

export interface RouteContextTab {
  path: string;
  order: number;
  restrictions?: RestrictedRouteObject['restrictions'];
}

interface Props {
  tabs?: Record<string, RouteContextTab>;
}

export const AppRouteContext = createContext<Props | undefined>(undefined);
export const RouteContext = (context: Props) => {
  if (!context?.tabs) return <Outlet />;

  return (
    <AppRouteContext.Provider value={context}>
      <Outlet context={context} />
    </AppRouteContext.Provider>
  );
};
